<script>
    import { createEventDispatcher } from 'svelte';

    export let total = 0;
    export let perpage = 12;
    export let show = 7;
    export let current_page = 1;

    $: num_pages = Math.ceil(total / perpage);
    $: break_point = Math.floor(show / 2)

    // una finestra sui numeri di pagine da mostrare che si sposta quando si cambia pagina
    let page_window;
    $: {
        if (num_pages <= show) {
            page_window = range(1, num_pages);
        } else {
            let start = Math.max(current_page - break_point, 1);
            let end = Math.min(Math.max(current_page + break_point, show), num_pages);
            let diff = show - (end - start + 1);

            page_window = range(start - diff, end);
        }
    }

    const dispatch = createEventDispatcher();

    function range(start, end) {
        return Array.from({length: ((end + 1) - start)}, (v, k) => k + start);
    }

    function changePage(num) {
        dispatch("change-page", { page: num })
    }
</script>

<div class="c-results__footer">
    <ul class="c-pagination">
        <!-- precedente -->
        <li class="c-pagination__item">
            <a on:click|preventDefault={() => changePage(current_page - 1)}
               class="c-pagination__link"
               class:c-pagination__link--disabled={current_page === 1}
               href="#"
               title="Pagina precedente">
                <i class="fas fa-chevron-left"></i>
            </a>
        </li>

        <!-- vai alla prima pagina -->
        {#if page_window[0] !== 1}
            <li class="c-pagination__item">
                <a class="c-pagination__link" href="#" on:click|preventDefault={() => changePage(1)}>
                    <span class="u-screen-reader-only">Vai a pagina </span>1
                </a>
            </li>
            <li class="c-pagination__item">
                <span class="c-pagination__dots">...</span>
            </li>
        {/if}

        <!-- vai a pagina N -->
        {#each page_window as page}
            <li class="c-pagination__item">
                <a class="c-pagination__link" class:c-pagination__link--selected={current_page === page}
                   href="#" on:click|preventDefault={() => changePage(page)}>
                    <span class="u-screen-reader-only">Vai a pagina </span>{page}
                </a>
            </li>
        {/each}

        <!-- val all'ultima pagina -->
        {#if page_window[page_window.length - 1] !== num_pages}
            <li class="c-pagination__item">
                <span class="c-pagination__dots">...</span>
            </li>
            <li class="c-pagination__item">
                <a class="c-pagination__link" href="#" on:click|preventDefault={() => changePage(num_pages)}>
                    <span class="u-screen-reader-only">Vai a pagina </span>{num_pages}
                </a>
            </li>
        {/if}

        <!-- successiva -->
        <li class="c-pagination__item">
            <a on:click|preventDefault={() => changePage(current_page + 1)}
               class="c-pagination__link"
               class:c-pagination__link--disabled={current_page === num_pages}
               href="#"
               title="Pagina successiva">
                <i class="fas fa-chevron-right"></i>
            </a>
        </li>
    </ul>

</div>